import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import {
  APPROVAL_TABLE_HEAD_BG,
  approvalFormTableStyles,
} from '@/components/Approval/@components/ApprovalFormTable/styles';

/** V2 카드·레거시 문서 카드(Bootstrap 클래스) 모두 태그·클래스로 스타일링 */
export const ClaimClosingRoot = styled(Box)(({ theme }) => ({
  width: '100%',
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  '& table': { ...approvalFormTableStyles(theme), minWidth: 800 },
  '& table th, & table td': { wordBreak: 'keep-all' },
  '& table.detail-lines': { width: 'max-content', minWidth: '100%' },
  '& table.detail-lines th, & table.detail-lines td': { whiteSpace: 'nowrap' },
  '& .text-center': { textAlign: 'center' },
  '& .text-right': { textAlign: 'right' },
  '& .textBold': { fontWeight: 600 },
  '& th.card-title': { fontWeight: 600 },
  '& th.card-action > *, & th.bg-title01 > *': { verticalAlign: 'middle' },
  '& th.card-action > * + *, & th.bg-title01 > * + *': { marginLeft: 4 },
  '& th.bg-gray, & td.bg-gray, & th.bg-title01': {
    backgroundColor: APPROVAL_TABLE_HEAD_BG,
    fontWeight: 500,
  },
  '& .bg-success': { backgroundColor: theme.palette.grey[50] },
  '& .bg-info': { backgroundColor: 'var(--dk-info-soft, #eef4ff)' },
}));

export const ClaimClosingDetailSheetBody = styled(Box)({
  padding: '16px 16px 24px',
});
